import {combineReducers} from 'redux'
import isResultReducer from "./isResultReducer"
import mainALLReducer from "./mainReducer"
import planConfigByStepReducer from "./planConfigByStepReducer"
import newAllReducers from './newReducer'
//IndexImportHygen
const allPlanTemplateReducers = combineReducers({
    isResultReducer,
    mainALLReducer,
    newAllReducers,
    planConfigByStepReducer,
    //IndexUsingHygen
})

export default allPlanTemplateReducers;